import { Abschnitt } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/entities/Abschnitt';
import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/entities/Arbeitsbereich';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/entities/Mitarbeiter';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/entities/Rotationsplan';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/entities/Station';
import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';

export const data: Rotationsplan[] = [
  new Rotationsplan({
    beruf: new Beruf({
      name: 'Hotelfachfrau',
      abkuerzung: 'HOFA',
      markierung: 'BROWN',
    }),
    mitarbeiter: new Mitarbeiter({
      id: 'm-1',
      vorname: 'Angelika',
      nachname: 'Müller',
    }),
    abschnitte: [
      new Abschnitt({
        id: 'abschnitt-1',
        name: '1. Lehrjahr',
        stationen: [
          new ArbeitsbereichStation({
            abschnittId: 'abschnitt-1',
            bereichsleiter: new Mitarbeiter({
              vorname: 'Taylor',
              nachname: 'Swift',
              id: '123456',
            }),
            von: new Date('2026-01-01'),
            bis: new Date('2026-06-30'),
            arbeitsbereich: new Arbeitsbereich({
              id: 'ab1',
              name: 'Housekeeping',
              markierung: 'YELLOW',
            }),
          }),
        ],
      }),
      new Abschnitt({
        id: 'abschnitt-2',
        name: '2. Lehrjahr',
        stationen: [
          new ArbeitsbereichStation({
            abschnittId: 'abschnitt-2',
            bereichsleiter: new Mitarbeiter({
              vorname: 'James',
              nachname: 'Bond',
              id: '2488387448',
            }),
            von: new Date('2027-01-01'),
            bis: new Date('2027-06-30'),
            arbeitsbereich: new Arbeitsbereich({
              id: 'ab2',
              name: 'Rezeption',
              markierung: 'BLUE',
            }),
          }),
        ],
      }),
    ],
  }),
  new Rotationsplan({
    beruf: new Beruf({
      name: 'Koch',
      abkuerzung: 'KOCH',
      markierung: 'GREEN',
    }),
    mitarbeiter: new Mitarbeiter({
      id: 'm-2',
      vorname: 'Max',
      nachname: 'Mustermann',
    }),
    abschnitte: [
      new Abschnitt({
        id: 'abschnitt-3',
        name: '1. Lehrjahr',
        stationen: [
          new ArbeitsbereichStation({
            abschnittId: 'abschnitt-3',
            bereichsleiter: new Mitarbeiter({
              vorname: 'Gordon',
              nachname: 'Ramsay',
              id: '987654',
            }),
            von: new Date('2025-09-01'),
            bis: new Date('2025-12-31'),
            arbeitsbereich: new Arbeitsbereich({
              id: 'ab3',
              name: 'Küche',
              markierung: 'RED',
            }),
          }),
        ],
      }),
      new Abschnitt({
        id: 'abschnitt-4',
        name: '2. Lehrjahr',
        stationen: [
          new ArbeitsbereichStation({
            abschnittId: 'abschnitt-4',
            bereichsleiter: new Mitarbeiter({
              vorname: 'Jamie',
              nachname: 'Oliver',
              id: '654321',
            }),
            von: new Date('2026-01-01'),
            bis: new Date('2026-07-31'),
            arbeitsbereich: new Arbeitsbereich({
              id: 'ab4',
              name: 'Patisserie',
              markierung: 'PINK',
            }),
          }),
        ],
      }),
    ],
  }),
  new Rotationsplan({
    beruf: new Beruf({
      name: 'Restaurantfachmann',
      abkuerzung: 'REFA',
      markierung: 'ORANGE',
    }),
    mitarbeiter: new Mitarbeiter({
      id: 'm-3',
      vorname: 'Sophie',
      nachname: 'Schmidt',
    }),
    abschnitte: [
      new Abschnitt({
        id: 'abschnitt-5',
        name: '1. Lehrjahr',
        stationen: [
          new ArbeitsbereichStation({
            abschnittId: 'abschnitt-5',
            bereichsleiter: new Mitarbeiter({
              vorname: 'Wolfgang',
              nachname: 'Puck',
              id: '112233',
            }),
            von: new Date('2026-04-01'),
            bis: new Date('2026-08-31'),
            arbeitsbereich: new Arbeitsbereich({
              id: 'ab5',
              name: 'Restaurant',
              markierung: 'ORANGE',
            }),
          }),
        ],
      }),
      new Abschnitt({
        id: 'abschnitt-6',
        name: '2. Lehrjahr',
        stationen: [
          new ArbeitsbereichStation({
            abschnittId: 'abschnitt-6',
            bereichsleiter: new Mitarbeiter({
              vorname: 'Alice',
              nachname: 'Waters',
              id: '445566',
            }),
            von: new Date('2027-03-01'),
            bis: new Date('2027-08-31'),
            arbeitsbereich: new Arbeitsbereich({
              id: 'ab6',
              name: 'Bar',
              markierung: 'CYAN',
            }),
          }),
        ],
      }),
    ],
  }),
];
